import { SET_SCAN_CODE } from './types';

const initialState = {
  scanCode: '',
};

export const scanCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SCAN_CODE:
      return { ...state, scanCode: action.payload };
    default:
      return state;
  }
};
